// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-header {
  justify-content: center;
  border-bottom: none;
}

.modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 10px;
  padding: 1rem 1.5rem;
}

#error-modal-dismiss-btn {
  width: 30%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/error-modal/error-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,oBAAA;AACJ;;AAEA;EACI,UAAA;AACJ","sourcesContent":[".modal-header {\r\n    justify-content: center;\r\n    border-bottom: none;\r\n}\r\n\r\n.modal-body {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    row-gap: 10px;\r\n    padding: 1rem 1.5rem;\r\n}\r\n\r\n#error-modal-dismiss-btn {\r\n    width: 30%;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
